<template>
    <div class="row">
        <div class="col-12 my-3">
            <div class="float-left f-12 align-items-center d-flex filterActivity btn-group crmButonGroupsType">
                <!-- <button class="btn-new btn mr-2 bg-transparent border-0 color-gray" @click="activtyDone='all'" :class="{'mcBgDark text-white':activtyDone=='all'}">
                    {{$ml.get('ALL')}}
                </button> -->
                <button class="btn btn-click h40" @click="activtyDone=false;datagetActivitiesByOrganization('false')" :class="{active:activtyDone==false}">
                    {{$ml.get('OPEN')}}
                </button>
                <button class="btn btn-click h40" @click="activtyDone=true;datagetActivitiesByOrganization('true')" :class="{active:activtyDone==true}">
                    {{$ml.get('CLOSED')}}
                </button>
            </div>
            <div class="float-right addBtn" data-toggle="modal" data-target="#addActivity">
                <button type="button" class="btn bg-new-primary f-14 h-100">
                    <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_ACTIVITY')}}
                </button>   
            </div>  
        </div>
        
        <div class="col-12 mb-3">
            <div class="float-left f-12 align-items-center d-flex filterActivity btn-group crmButonGroupsType">
                <button class="btn btn-click h40" @click="activtyDone='all';datagetActivitiesByOrganization('0')" :class="{active:activtyDone=='all'}">
                    {{$ml.get('ALL')}}
                </button>
                <button class="btn btn-click h40" @click="activtyDone='call';datagetActivitiesByOrganization('1')" :class="{active:activtyDone=='call'}">
                    <i class="fa fa-phone-volume mr-1" style="color:#52BA9F"></i> 
                    {{$ml.get('CALL')}}
                </button>
                <button class="btn btn-click h40" @click="activtyDone='task';datagetActivitiesByOrganization('3')" :class="{active:activtyDone=='task'}">
                    <i class="fa fa-tasks mr-1" style="color:#49A7F8"></i>
                    {{$ml.get('TASK')}}
                </button>
                <button class="btn btn-click h40" @click="activtyDone='email';datagetActivitiesByOrganization('4')" :class="{active:activtyDone=='email'}">
                    <i class="fa fa-envelope mr-1" style="color:#F6BD56"></i>
                    {{$ml.get('E_MAIL')}}
                </button>
                <button class="btn btn-click h40" @click="activtyDone='appointment';datagetActivitiesByOrganization('2')" :class="{active:activtyDone=='appointment'}">
                    <i class="fas fa-calendar-check mr-1" style="color:#9666F6"></i>
                    {{$ml.get('APPOINTMENT')}}
                </button>
                <button class="btn btn-click h40" @click="activtyDone='whatsapp'" :class="{active:activtyDone=='whatsapp'}">
                    <i class="fab fa-whatsapp mr-1" style="color:#25d366"></i>
                    WhatsApp
                </button>
            </div>
        </div>

        <div v-if="filterData.length>0" class="w-100">
            <div v-if='field==="org" || field==="deal"' class="col-12">
                <template v-for='(i,index) in filterData' :key="index">
                    <div class="row m-0 pt-3 box-shadow border-radius-4 mb-3 activityDetail" v-if="filterData.length!=0">
                    <div class="col-12 f-12">
                        <div class="d-flex justify-content-between">
                            <div class="float-left">
                                <button class="btn-new bg-new-darkGray text-white">{{activitiesType(i.type, $ml)}}</button>
                                <button class="btn-new bg-new-gray" v-if="i.cuid.$oid!=undefined && users.find(usr => usr._id['$oid']==i.cuid.$oid)!=null">
                                    {{users.find(usr => usr._id['$oid']==i.cuid.$oid).name}}
                                    {{users.find(usr => usr._id['$oid']==i.cuid.$oid).surName}}
                                </button>
                            </div>
                            <div class="float-right">
                                <span class="btn-new f-12 p-1" v-if="!i.done">{{$ml.get('OPEN')}}</span>
                                <span class="btn-new f-12 p-1 bg-new-darkGray text-white" v-else>{{$ml.get('CLOSED')}}</span>
                                <label class="clickable pb-0 ml-2 d-none d-md-inline-block" @click="dataFilling(i)" v-if="!i.done"><i class="fas fa-pencil-alt"></i></label>
                            </div>
                        </div>
                        <div class="title my-4 f-13">{{i.subject}}</div>
                        <div class="my-2 color-gray" v-if="i.dueDate!=undefined">{{$ml.get('PLANNING_HISTORY')}} : <span class="light-darkGray-color">{{formatDate(new Date(i.dueDate.$date), "Do MMMM YYYY")}}</span></div>
                        <div class="my-2 color-gray" v-if="i.doneDate!=undefined">{{$ml.get('CLOSING_DATE')}} : <span class="light-darkGray-color">{{formatDate(new Date(i.doneDate.$date), "Do MMMM YYYY")}}</span></div>
                        <div id="accordion" class="row mt-4" v-if="i.notes!==undefined && i.notes.length>0">
                            <div class="dropdown-toggle col-12 d-flex justify-content-between cursor-pointer" :id="'collapses'+index" data-toggle="collapse" :data-target="'#'+'collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                                <span class="float-left shortNote" v-html="filterNameNot(i.notes[i.notes.length-1].text)"></span>
                                <i class="fa fa-plus-circle f-18"></i>
                            </div>
                            
                            <div :id="'collapse'+index" class="collapse col-12" :aria-labelledby="'collapses'+index" data-parent="#accordion">
                                <ul class="list-unstyled m-0">
                                    <li v-for="not in i.notes" class="border-bottom py-3">
                                        <label class="m-0 w-100 f-w-semibold">{{formatDate(new Date(not.created_at.$date), "Do MMMM YYYY hh:mm:ss")}}</label>
                                        <label class="m-0 text-dark mt-2"  v-if="not!==undefined" v-html="not.text"></label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                </template>
            </div>
            

            <!-- değişiklik burada yapmıştım -->
            <div v-if='field==="orgContact"' class="col-12">
                <template v-for='(i,index) in filterData' :key="index">
                    <div class="row m-0 pt-3 box-shadow border-radius-4 mb-3 activityDetail" v-if='i.contactId!==undefined'>
                    
                    <div class="col-12 f-12">
                        <div class="d-flex justify-content-between">
                            <div class="float-left">
                                <button class="btn-new bg-new-darkGray text-white">{{activitiesType(i.type, $ml)}}</button>
                                <button class="btn-new bg-new-gray" v-if="i.cuid.$oid!=undefined">
                                    {{users.find(usr => usr._id['$oid']==i.cuid.$oid).name}}
                                    {{users.find(usr => usr._id['$oid']==i.cuid.$oid).surName}}
                                </button>
                                <template v-for="(contact, cIdx) in data.contacts" :key="cIdx">
                                    <button class="btn-new bg-new-gray" v-if='data.contacts !== undefined && i.contactId!==undefined && contact._id.$oid===i.contactId[0]._id.$oid' @click="contactCard(i.contactId[0]._id.$oid)"><i class="fa fa-user text-primary"></i> {{contact.n}} {{contact.sn}}</button>
                                </template>
                            </div>
                            <div class="float-right">
                                <span class="btn-new f-12 p-1" v-if="!i.done">{{$ml.get('OPEN')}}</span>
                                <span class="btn-new f-12 p-1 bg-new-darkGray text-white" v-else>{{$ml.get('CLOSED')}}</span>
                                <label class="clickable pb-0 ml-2" @click="dataFilling(i)" v-if="!i.done"><i class="fas fa-pencil-alt"></i></label>
                            </div>
                        </div>
                        <div class="title my-4 f-13">{{i.subject}}</div>
                        <div class="my-2 color-gray" v-if="i.dueDate!=undefined">{{$ml.get('PLANNING_HISTORY')}} : <span class="light-darkGray-color">{{formatDate(new Date(i.dueDate.$date), "Do MMMM YYYY")}}</span></div>
                        <div class="my-2 color-gray" v-if="i.doneDate!=undefined">{{$ml.get('CLOSING_DATE')}} : <span class="light-darkGray-color">{{formatDate(new Date(i.doneDate.$date), "Do MMMM YYYY")}}</span></div>
                        <div id="accordion" class="row mt-4" v-if="i.notes!==undefined">
                            <div class="dropdown-toggle col-12 d-flex justify-content-between cursor-pointer" :id="'collapses'+index" data-toggle="collapse" :data-target="'#'+'collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                                <span class="float-left shortNote" v-html="filterNameNot(i.notes[i.notes.length-1].text)"></span>
                                <i class="fa fa-plus-circle f-18"></i>
                            </div>
                            
                            <div :id="'collapse'+index" class="collapse col-12" :aria-labelledby="'collapses'+index" data-parent="#accordion">
                                <ul class="list-unstyled m-0">
                                    <li v-for="not in i.notes" class="border-bottom py-3">
                                        <label class="m-0 w-100 f-w-semibold">{{formatDate(new Date(not.created_at.$date), "Do MMMM YYYY hh:mm:ss")}}</label>
                                        <label class="m-0 text-dark mt-2"  v-if="not!==undefined" v-html="not.text"></label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                </template>
            </div>
        </div>
        <div v-else-if="activtyDone !== 'whatsapp'" class="col-12">
            <div role="alert" class="alert alert-secondary alert-dismissible fade show mt-3">
                {{$ml.get('NO_RELATED_ACTIVITIES')}}
            </div>
        </div>

        <div class="col-12" v-if="showWhatsAppMessages && (whatsAppMessagesLoading || whatsAppMessages.length || activtyDone === 'whatsapp')">
            <div class="d-flex align-items-center mt-3 mb-2">
                <i class="fab fa-whatsapp text-success mr-2"></i>
                <strong>WhatsApp Konuşmaları</strong>
            </div>
            <div v-if="whatsAppMessagesLoading" class="text-muted py-2">WhatsApp mesajları yükleniyor...</div>
            <div v-for="conversation in whatsAppConversations" :key="conversation.id" class="row m-0 pt-3 box-shadow border-radius-4 mb-3 activityDetail whatsapp-activity">
                <div class="col-12 f-12">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <span class="btn-new bg-new-darkGray text-white"><i class="fab fa-whatsapp mr-1"></i> WhatsApp</span>
                            <button class="whatsapp-activity-toggle ml-2" type="button" @click="toggleWhatsAppConversation(conversation.id)">
                                <i class="fas mr-1" :class="openWhatsAppConversationId === conversation.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                Tüm mesajları görüntüle ({{ conversation.messages.length }} mesaj)
                            </button>
                        </div>
                        <button class="btn btn-sm btn-outline-success" type="button" @click="goToWhatsAppConversation(conversation.id)">Konuşmaya Git</button>
                    </div>
                    <button class="whatsapp-activity-preview d-flex justify-content-between align-items-center mt-3 w-100" type="button" @click="toggleWhatsAppConversation(conversation.id)">
                        <span class="text-muted text-truncate pr-3">{{ conversation.lastMessage.body || 'İçerik bulunamadı.' }}</span>
                        <small class="text-muted text-nowrap">{{ formatWhatsAppDate(conversation.lastMessage.date) }}</small>
                    </button>
                    <div v-show="openWhatsAppConversationId === conversation.id" class="whatsapp-activity-messages mt-3">
                        <div v-for="message in conversation.messages" :key="message.id" class="d-flex mb-2" :class="message.outgoing ? 'justify-content-end' : 'justify-content-start'">
                            <div class="whatsapp-activity-message" :class="message.outgoing ? 'whatsapp-activity-message-outgoing' : 'whatsapp-activity-message-incoming'">
                                <div>{{ message.body || 'İçerik bulunamadı.' }}</div>
                                <small>{{ formatWhatsAppDate(message.date) }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!whatsAppMessagesLoading && !whatsAppMessages.length && activtyDone === 'whatsapp'" role="alert" class="alert alert-secondary alert-dismissible fade show mt-3">
                WhatsApp mesajı bulunamadı.
            </div>
        </div>
        
        <div class="modal" tabindex="-1" ref="modalActivity" role="dialog" id="activity" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content border-radius-20 border-line-80">
                <div class="modal-header">
                    <h5 class="modal-title f-14 font-family-bold f-w-normal">{{$ml.get('ACTIVITY_AS_COMPLETED')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-footer dealBtnStyle">
                    <button type="button" class="btn btn-secondary font-family-bold f-14 f-w-normal h-32" data-dismiss="modal">{{$ml.get('NO')}}</button>
                    <button type="button" class="btn btn-primary font-family-bold f-14 f-w-normal h-32" @click="update()">{{$ml.get('YES')}}</button>
                </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        
    </div>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import { activityType as activitiesType } from '@/services/resultTableFormatters'
export default {
    name: 'activitiesDetailPanel',
    data () {
        return {
            activityId:"",
            activtyDone:"all",
            whatsAppMessages: [],
            whatsAppMessagesLoading: false,
            openWhatsAppConversationId: '',
        }
    },
    computed: {
        ...mapState([
            'baseUrl'
        ]),
        filterData(){
            var activities=[]
            //this.sortItems()
            for(var activity in this.data){
                if((this.data[activity].done==false||this.data[activity].done==undefined)&&this.activtyDone==false){
                    activities.push(this.data[activity])
                }else if(this.data[activity].done==true&&this.activtyDone==true){
                    activities.push(this.data[activity])
                }else if(this.activtyDone=='all'){
                    activities=this.data
                }
                else if(this.data[activity].type==1 && this.activtyDone=='call'){
                    activities.push(this.data[activity])
                }
                else if(this.data[activity].type==2 && this.activtyDone=='appointment'){
                    activities.push(this.data[activity])
                }
                else if(this.data[activity].type==4 && this.activtyDone=='email'){
                    activities.push(this.data[activity])
                }
                else if(this.data[activity].type==3 && this.activtyDone=='task'){
                    activities.push(this.data[activity])
                }
            }
            return activities
        },
        showWhatsAppMessages(){
            return this.activtyDone === 'all' || this.activtyDone === 'whatsapp'
        },
        whatsAppConversations(){
            const conversations = {}
            this.whatsAppMessages.forEach((message) => {
                const conversationId = message.conversationId || 'contact-whatsapp-messages'
                if(!conversations[conversationId]) conversations[conversationId] = { id: conversationId, messages: [] }
                conversations[conversationId].messages.push(message)
            })
            return Object.values(conversations).map((conversation) => {
                conversation.messages.sort((left, right) => new Date(left.date).getTime() - new Date(right.date).getTime())
                conversation.lastMessage = conversation.messages[conversation.messages.length - 1]
                return conversation
            }).sort((left, right) => new Date(right.lastMessage.date).getTime() - new Date(left.lastMessage.date).getTime())
        }
    },
    props:["data","field","tabs","deal","users","contactId"],
    methods:{
        activitiesType,
        formatDate(value, format){
            return this.$moment(value).format(format)
        },
        filterNameNot(value){
            if (!value) return '';
            value = String(value);
            if (value.length > 60) {
                return value.substring(0, 60) + '...';
            }
            return value;
        },
        extractWhatsAppMessages(response){
            const content = response && response.data && response.data.content ? response.data.content : {}
            const keys = ['whatsapp_messages', 'whatsAppMessages', 'messages', 'items', 'results']
            for(const key of keys){
                if(Array.isArray(content[key])) return content[key]
            }
            return []
        },
        normalizeWhatsAppMessage(message, index){
            const sender = String(message.sender || '').trim().toLowerCase()
            const direction = String(message.direction || message.type || '').trim().toLowerCase()
            const content = message.messageBody || message.body || message.content || message.text || ''
            const rawDate = message.createdAt || message.created_at || message.sentAt || message.timestamp || message.date || message.addDate
            return {
                id: String((message._id && message._id.$oid) || message._id || message.id || message.messageId || `${rawDate}-${index}`),
                body: typeof content === 'object' ? (content.body || content.messageBody || content.content || content.text || '') : content,
                date: rawDate && rawDate.$date ? rawDate.$date : rawDate,
                conversationId: String((message.conversationId && message.conversationId.$oid) || message.conversationId || (message.whatsAppConversationId && message.whatsAppConversationId.$oid) || message.whatsAppConversationId || (message.whatsappConversationId && message.whatsappConversationId.$oid) || message.whatsappConversationId || (message.conversation_id && message.conversation_id.$oid) || message.conversation_id || (message.whatsapp_conversation_id && message.whatsapp_conversation_id.$oid) || message.whatsapp_conversation_id || (message.conversation && ((message.conversation._id && message.conversation._id.$oid) || message.conversation._id || message.conversation.id)) || ''),
                outgoing: ['me', 'self', 'user', 'agent', 'business', 'company', 'crm', 'outgoing', 'outbound', 'sent'].includes(sender) || message.fromMe === true || message.isOutgoing === true || ['outgoing', 'outbound', 'sent'].includes(direction)
            }
        },
        formatWhatsAppDate(value){
            if(!value) return ''
            return this.$moment(value).format('DD MMMM YYYY HH:mm')
        },
        getWhatsAppMessagesByContact(){
            if(!this.contactId) return
            this.whatsAppMessagesLoading = true
            axios({
                method: 'POST',
                url: '/getWhatsAppMessagesByContact',
                baseURL: this.baseUrl,
                data: { contactId: this.contactId, limit: 50, skip: 0 },
                withCredentials: true
            }).then((response) => {
                if(response.data && response.data.status && String(response.data.status.code) === '0'){
                    this.whatsAppMessages = this.extractWhatsAppMessages(response).map(this.normalizeWhatsAppMessage)
                }
            }).finally(() => {
                this.whatsAppMessagesLoading = false
            })
        },
        toggleWhatsAppConversation(conversationId){
            this.openWhatsAppConversationId = this.openWhatsAppConversationId === conversationId ? '' : conversationId
        },
        goToWhatsAppConversation(conversationId){
            if(!conversationId || conversationId === 'contact-whatsapp-messages') return
            this.$router.push({ path: '/whatsapp', query: { conversationId } })
        },
        dataFilling(data){
            this.$emit("updateActivity",data)
            $('#addActivity').modal('show')
        },
        datagetActivitiesByOrganization(data){
            this.$emit("datagetActivitiesByOrganization",data)
        },
        activityDoneFF(){
            this.activtyDone="all"
        },
        update(){
            let url = "updateActivity"
            let dataObj={}
            let obj={}
            obj={
                "done":true
            }
            dataObj["objId"]=this.activityId
            dataObj["updateObj"]=obj
            this.postActivities(url,dataObj)
        },
        postActivities(url,obj){
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('ACTIVITY_UPDATE'),
                        text: res.data.status.desc 
                    })
                    this.$emit('refleshData')
                    $('#activity').modal('hide')
                    //this.$emit('getData',res.data.content.activities)
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        organizationCard(id){
            if(id!==""){
                localStorage.orgId=id
                this.updateOrgId(id)
                window.open('/organizationCard/'+id, '_blank');
            }
        },
        contactCard(id){
            if(id!==""){
                localStorage.contactId=id
                this.updateContactId(id)
                window.open('/contactCard/'+id, '_blank');
            }
        },
        dealCard(id){
            if(id!==""){
                localStorage.dealId=id
                this.updateDealId(id)
                window.open('/dealCard/'+id, '_blank');
            }
        },
        ...mapActions([
            'updateOrgId',
            'updateContactId',
            'updateDealId'
        ]),
        //   sortedItems(){
//           var dates =[]; 
//        for(let i=0; i < this.data.length; i++){
//              var dates =  this.data[i].addDate.$date
//                 console.log(dates);
//               } 
//     var isDescending =true;
//      var add = dates.sort((a,b) => isDescending ? new Date(b).getTime() - new Date(a).getTime() : new Date(a).getTime() - new Date(b).getTime());
//     console.log(add)
//     },    
    },
    created(){
        this.getWhatsAppMessagesByContact()
    },
    watch:{
        activtyDone(){
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shortNote :deep(p){
    float: left;
    margin: 0;
}
.iptal:before{
    color:red
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #66D0FF80;
}
.btnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 27px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 10px;
}
.btnStyle button.active {
  background-color: #66D0FF!important;
  border: 1px solid #66D0FF;
  color: white;
}
.dealBtnStyle button {
  font-family: "font-family-bold";
  border-radius: 20px;
  background-color: white;
  height: 27px;
  border: 1px solid #66D0FF80;
  color: #66D0FF;
  font-weight: normal;
  font-size: 10px;
}
.dealBtnStyle button.active {
  background-color: #66D0FF!important;
  border: 1px solid #66D0FF;
  color: white;
}
.clickable{
    cursor: pointer;
}
.activityDetail:hover .dropdown-toggle{
    background-color: #EEF3F9;
}
.activityDetail:hover .dropdown-toggle i{
    color: #1991EB;
}
.dropdown-toggle p {
    margin: 0;
}
.dropdown-toggle {
    height: 30px;
    display: flex;
    align-items: center;
}
.whatsapp-activity { border-left: 3px solid #25d366; }
.whatsapp-activity-toggle, .whatsapp-activity-preview { padding: 4px 6px; border: 0; border-radius: 4px; background: transparent; color: #6c757d; text-align: left; cursor: pointer; transition: background-color .15s ease, color .15s ease; }
.whatsapp-activity-toggle:hover, .whatsapp-activity-preview:hover { background: #eef3f9; color: #1991eb; }
.whatsapp-activity-messages { max-height: 360px; padding: 12px; overflow-y: auto; border-radius: 4px; background: #efeae2; }
.whatsapp-activity-message { max-width: 78%; padding: 8px 10px; border-radius: 8px; white-space: pre-wrap; word-break: break-word; }
.whatsapp-activity-message-incoming { background: #fff; }
.whatsapp-activity-message-outgoing { background: #d9fdd3; }
.whatsapp-activity-message small { display: block; margin-top: 3px; text-align: right; color: #6c757d; font-size: 10px; }
#accordion .dropdown-toggle:after{
    display: none;
}
#accordion p {
    margin: 0;
}
@media (max-width: 768px) {
    .filterActivity{
        width: 100%;
    }
    .filterActivity>button{
        width: inherit;
        margin:0 !important;
    }
}
</style>
